import { render, staticRenderFns } from "./EditEPaper.vue?vue&type=template&id=2fb913c6&scoped=true&"
import script from "./EditEPaper.vue?vue&type=script&lang=js&"
export * from "./EditEPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb913c6",
  null
  
)

export default component.exports